export const InvalidTypeError = (type: string) => {
	return new Error(`Invalid type: ${type}, please check!`);
};
